// @flow

import fetchCommand from './commands/fetch-cmd';
import bindCommand from './commands/bind-cmd';
import importCommand from './commands/import-cmd';
import watchCommand from './commands/watch-cmd';

const commands = [
  fetchCommand,
  bindCommand,
  importCommand,
  watchCommand,
];

export default commands;

export type Command = {
  name: string,
  description?: ?string,
  arguments?: ?Array<{name: string, description: string}>,
  action: (args: Object, options: Object) => Promise<any>,
  report: (any) => string,
  handleError?: ?(e: Error) => string
};
